<template>
     <div class="rules_info">
        <p class="title">活动说明</p>
        <p class="info_item">1.分享本页面或发送邀请码给好友。</p>
        <p class="info_item">2.被邀请的好友下载打开 “我是谜” ，注册并填写您的邀请码。</p>
        <p class="info_item">3.被邀请人需满足累计签到15天并累计游玩5个剧本,视作邀请成功。</p>
        <p class="info_item">5.邀请成功后，邀请人和被邀请人都将获得奖励。</p>
      </div>
</template>
<script>
export default {
    name:"Rules"
}
</script>
<style scoped>
.invite .invite_bgdwn .rules_info {
  position: absolute;
  top: 23.575rem;
  left: 1.125rem;
  width: 16.5rem;
  height: 8.5rem;
}
.invite .invite_bgdwn .rules_info .title {
  font-family: "PingFang-SC-Heavy";
  font-size: 0.8rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.675rem;
  letter-spacing: 0rem;
  color: #ffffff;
  text-align: center;
  margin-bottom: 1.2rem;
}
.invite .invite_bgdwn .rules_info .info_item {
  font-family: "PingFang-SC-Regular";
  font-size: 0.6rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #ffffff;
  text-align: left;
  margin-bottom: 0.575rem;
}
</style>





// WEBPACK FOOTER //
// src/Component/Rules.vue